export default __webpack_public_path__ + "static/parp-9451118f94c7e081e04ae4a75cf85ad7.png";